import React, { useEffect } from 'react';

import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';
import appConfig from '@nerdwallet/app-config';
import useAnalytics, { MatchParams } from './useAnalytics';
import usePageViewId from '~/client/lib/segment/usePageViewId';

type SegmentTrackingProps = {
  segmentPageName: string;
  matchParams: MatchParams;
};

const SegmentTracking = ({
  segmentPageName,
  matchParams,
}: SegmentTrackingProps): JSX.Element => {
  const { trackSegmentPageEvent } = useAnalytics();
  const pageViewId = usePageViewId();

  useEffect(() => {
    trackSegmentPageEvent(segmentPageName, pageViewId, matchParams);
  }, [segmentPageName, matchParams, pageViewId, trackSegmentPageEvent]);

  return (
    <div>
      <GlobalMarkupOptions>
        {{
          segmentTrackingAttributes: {
            driverPageName: segmentPageName,
            // eslint-disable-next-line no-underscore-dangle
            deployableName: appConfig?._meta?.deployable,
            // eslint-disable-next-line no-underscore-dangle
            deployableVersion: appConfig?._meta?.version,
            driverPageViewId: pageViewId,
          },
        }}
      </GlobalMarkupOptions>
    </div>
  );
};

export default SegmentTracking;
